<div class="loader-container" 
    [ngStyle]="{'background-color': fullOpacity ? 'rgba(255, 255, 255, 1)' : null }">
    <div id="spinner-container"></div>
</div>